export const variants = {
  primary: {
    active: {
      background: 'hero.plum',
      border: 'hero.plum',
    },
  },
  yellow: {
    active: {
      background: 'secondary.yellow',
      border: 'hero.plum',
    },
  },
  lilac: {
    active: {
      background: 'hero.lilac',
      border: 'hero.plum',
    },
  },
};
